import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {CurrencyFormatter} from "../../../utils/formatters";

class RoyaltyPaymentForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="licensor"
                            labelKey="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Jogtulajdonos"
                        />
                    </div>
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="licensee"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Jogosult"
                        />
                    </div>
                    <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="payment_date"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Dátum"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="items"
                            columns={{
                                "id": {
                                    header: 'Kód',
                                    width: 1,
                                    sortable: true,
                                    filterable: true
                                },
                                "royalty.object_component.displayname": {
                                    header: 'Megnevezés',
                                    width: 9,
                                    sortable: true,
                                    filterable: true
                                },
                                "amount": {
                                    header: 'Összesen',
                                    width: 1,
                                    sortable: true,
                                    filterable: true,
                                    renderer: CurrencyFormatter
                                },
                                "vat.name": {
                                    header: 'Áfa',
                                    className: 'nowrap',
                                    width: 1,
                                    sortable: true,
                                    filterable: true,
                                }
                            }}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Tételek"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(RoyaltyPaymentForm);
